import { useDebugValue, useEffect, useRef } from 'react';

export function useOnce(effect) {
  const called = useRef(false);
  useDebugValue(called.current);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []); // exhaustive-deps check is disabled for this line since the here the array needs to be empty to ensure triggering of the effect only once!
}
